import { Grid2 } from '@mui/material';
import CircularProgressWithLabel from '../circularProgress/CircularProgress';
import styles from './NutritionalProgressContainer.module.css';

const NutritionalProgressContainer = ({nutritionalValues}:{nutritionalValues: any}) => {
    return (
        <Grid2 className={styles.progress_container}>
            {nutritionalValues.map((nutritionalValue: { label: string; value: number; maxValue: number; unit: string }) => (
                <CircularProgressWithLabel
                    currentValue={nutritionalValue.value}
                    maxValue={nutritionalValue.maxValue}
                    label={nutritionalValue.label}
                    unit={nutritionalValue.unit}
                />  

            ))}

            
        </Grid2>
    )
}

export default NutritionalProgressContainer